export default "__VITE_ASSET__567ee118__"